import React from "react";
import { Routes, Route } from "react-router-dom";
import "../academy/academy.scss";
import MeProgress from "./MeProgress";
import MeProfile from "./MeProfile";
import MeCertificates from "./MeCertificates";
import MeCertificateDetail from "./MeCertificateDetail";
import MeLiveShift from "./MeLiveShift";
import MeApplications from "./MeApplications";
import MeApplication from "./MeApplication";
import CreatorScripts from "./creator/CreatorScripts";
import CreatorScriptDetail from "./creator/CreatorScriptDetail";
import CreatorIntro from "./creator/CreatorIntro";
import CreatorMyWork from "./creator/CreatorMyWork";
import CreatorUploadWorkspace from "./creator/CreatorUploadWorkspace";
import CreatorPayments from "./creator/CreatorPayments";

export default function MeCenter() {
  return (
    <Routes>
      <Route index element={<MeProgress />} />
      <Route path="profile" element={<MeProfile />} />
      <Route path="certificates" element={<MeCertificates />} />
      <Route path="certificates/:programSlug/:certSlug" element={<MeCertificateDetail />} />
      <Route path="live-shift" element={<MeLiveShift />} />
      <Route path="applications" element={<MeApplications />} />
      <Route path="applications/:id" element={<MeApplication />} />
      <Route path="creator" element={<CreatorScripts />} />
      <Route path="creator/intro" element={<CreatorIntro />} />
      <Route path="creator/scripts/:id" element={<CreatorScriptDetail />} />
      <Route path="creator/work" element={<CreatorMyWork />} />
      <Route path="creator/work/:submissionId" element={<CreatorUploadWorkspace />} />
      <Route path="creator/payments" element={<CreatorPayments />} />
    </Routes>
  );
}
